import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logolatest from '../assets/images/logos/logolatest.jpg';

const LoggedInHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const { logout, userType } = useAuth();

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 991.98);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    navigate('/Login');
  };

  // Navigate to dashboard based on user type
  const navigateToDashboard = () => {
    switch (userType) {
      case 'student':
        navigate('/student-dashboard');
        break;
      case 'accommodation_provider':
        navigate('/provider-dashboard');
        break;
      case 'back_office':
        navigate('/backoffice-dashboard');
        break;
      case 'primary_representative':
      case 'secondary_representative':
      case 'bmo_officer':
      case 'funder_primary_representative':
      case 'funder_secondary_representative':
      case 'funder_officer':
        navigate('/general-dashboard');
        break;
      case 'bmo_user_admin':
        navigate('/bmo-user-admin-dashboard');
        break;
      case 'inspector':
        navigate('/inspector-dashboard');
        break;
      default:
        navigate('/general-dashboard');
    }
    closeMenu();
  };

  // Dynamic styles based on screen size
  const getCollapseStyles = () => {
    const baseStyles = {
      transition: 'all 0.3s ease-in-out'
    };

    if (isMobile) {
      return {
        ...baseStyles,
        backgroundColor: 'white',
        position: 'absolute',
        top: '100%',
        left: '0',
        right: '0',
        zIndex: 1000,
        boxShadow: isMenuOpen ? '0 2px 10px rgba(0,0,0,0.1)' : 'none',
        borderRadius: '0 0 8px 8px',
        padding: isMenuOpen ? '0.5rem 0' : '0'
      };
    }

    return baseStyles;
  };

  const getNavLinkStyles = () => {
    const baseStyles = {
      color: 'black',
      fontSize: '1.2rem',
      padding: '0.8rem 1rem',
      display: 'block',
      textDecoration: 'none'
    };

    if (isMobile) {
      return {
        ...baseStyles,
        backgroundColor: 'white'
      };
    }

    return baseStyles;
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white" style={{
      padding: '1rem 0',
      minHeight: '80px',
      position: isMobile ? 'relative' : 'static'
    }}>
      <style>{`
        .logged-in-nav-link {
          color: black !important;
          font-size: 1.2rem !important;
          padding: 0.8rem 1rem !important;
          display: block !important;
          text-decoration: none !important;
          background-color: transparent !important;
          border: none !important;
          cursor: pointer !important;
        }
        .logged-in-nav-link:hover {
          background-color: #f8f9fa !important;
        }
      `}</style>
      <div className="container" style={{ position: isMobile ? 'relative' : 'static' }}>
        <Link className="navbar-brand" to="/" onClick={closeMenu}>
          <img 
            src={logolatest}
            alt="Studorez Logo" 
            style={{ height: '50px', width: 'auto' }}
          />
        </Link>
        
        {/* Mobile Menu Toggle Button */}
        <button 
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="navbarNav" 
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
          style={{
            border: 'none',
            outline: 'none',
            background: 'transparent'
          }}
        >
          <span style={{
            display: 'block',
            width: '25px',
            height: '3px',
            backgroundColor: '#333',
            margin: '3px 0',
            transition: '0.3s',
            transform: isMenuOpen ? 'rotate(-45deg) translate(-5px, 6px)' : 'none'
          }}></span>
          <span style={{
            display: 'block',
            width: '25px',
            height: '3px',
            backgroundColor: '#333',
            margin: '3px 0',
            transition: '0.3s',
            opacity: isMenuOpen ? '0' : '1'
          }}></span>
          <span style={{
            display: 'block',
            width: '25px',
            height: '3px',
            backgroundColor: '#333',
            margin: '3px 0',
            transition: '0.3s',
            transform: isMenuOpen ? 'rotate(45deg) translate(-5px, -6px)' : 'none'
          }}></span>
        </button>

        {/* Navigation Menu */}
        <div 
          className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} 
          id="navbarNav"
          style={getCollapseStyles()}
        >
          <ul className="navbar-nav ms-auto" style={{ backgroundColor: isMobile ? 'white' : 'transparent' }}>
            <li className="nav-item">
              <Link 
                className="nav-link logged-in-nav-link" 
                to="/" 
                onClick={closeMenu}
                style={getNavLinkStyles()}
              >
                Home
              </Link>
            </li>

            <li className="nav-item">
              <Link 
                className="nav-link logged-in-nav-link" 
                to="#" 
                onClick={(e) => {
                  e.preventDefault();
                  navigateToDashboard();
                }}
                style={getNavLinkStyles()}
              >
                Dashboard
              </Link>
            </li>

            <li className="nav-item">
              <Link 
                className="nav-link logged-in-nav-link" 
                to="/Login" 
                onClick={(e) => {
                  e.preventDefault();
                  handleLogout();
                  closeMenu();
                }}
                style={getNavLinkStyles()}
              >
                Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default LoggedInHeader;
